// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 26/10/2023
 */

.Details_container__Umbrs {
    border-radius: 0.5rem;
    margin-top: 1.8rem;
    margin-bottom: 2rem;
    /* padding: 3rem 1rem; */
    filter: drop-shadow(1px 1px 20px rgba(39, 108, 153, 0.50));
    /* background: linear-gradient(180deg, #FFF 99.99%, rgba(246, 246, 246, 0.00) 100.07%); */
}

.Details_cardContainer__S-Nyu {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* margin: 0.5rem; */
    padding: 1rem 1.5rem;
    padding-bottom: 3rem;
    align-items: center;
    border-radius: 0.5rem;
    /* border: 1px solid rgba(101, 127, 173, 0.50); */
    background: rgba(101, 127, 173, 0.10);
}

.Details_icon__gRs9K {
    width: 5.25rem;
    height: 5.25rem;
    margin-top: 1rem;
}

.Details_title__N3uM\\+ {
    color: #000;
    text-align: center;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 500;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
}

.Details_description__IfR\\+k {
    color: #000;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 300;
    line-height: 1.875rem;
    text-align: center;
    height: 6rem;
}

/* for mobile */
@media (max-width: 770px) {
    .Details_container__Umbrs {
        background: white;
        padding: 0rem;
        margin-bottom: 1rem;
        margin-top: 1rem;
        filter: none;
    }

    .Details_cardContainer__S-Nyu {
        border-radius: 0.5rem;
        padding: 1rem;
        min-height: 10rem;
        margin-bottom: 0.5rem;
    }

    .Details_icon__gRs9K {
        width: 2rem;
        height: 2rem;
        margin-top: 0rem;
    }

    .Details_title__N3uM\\+ {
        font-size: 0.875rem;
        margin-top: 0.2rem;
        margin-bottom: 0.7rem;
    }

    .Details_description__IfR\\+k {
        font-size: 0.75rem;
        font-weight: 300;
        line-height: 1.2rem;
        height: 4.5rem;        

    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/Details.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,0DAA0D;IAC1D,yFAAyF;AAC7F;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,iDAAiD;IACjD,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,eAAe;AACf;IACI;QACI,iBAAiB;QACjB,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,aAAa;QACb,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;;IAElB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 26/10/2023\r\n */\r\n\r\n.container {\r\n    border-radius: 0.5rem;\r\n    margin-top: 1.8rem;\r\n    margin-bottom: 2rem;\r\n    /* padding: 3rem 1rem; */\r\n    filter: drop-shadow(1px 1px 20px rgba(39, 108, 153, 0.50));\r\n    /* background: linear-gradient(180deg, #FFF 99.99%, rgba(246, 246, 246, 0.00) 100.07%); */\r\n}\r\n\r\n.cardContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    /* margin: 0.5rem; */\r\n    padding: 1rem 1.5rem;\r\n    padding-bottom: 3rem;\r\n    align-items: center;\r\n    border-radius: 0.5rem;\r\n    /* border: 1px solid rgba(101, 127, 173, 0.50); */\r\n    background: rgba(101, 127, 173, 0.10);\r\n}\r\n\r\n.icon {\r\n    width: 5.25rem;\r\n    height: 5.25rem;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.title {\r\n    color: #000;\r\n    text-align: center;\r\n    font-size: 1.2rem;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    margin-top: 1.5rem;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.description {\r\n    color: #000;\r\n    font-size: 0.9rem;\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    line-height: 1.875rem;\r\n    text-align: center;\r\n    height: 6rem;\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .container {\r\n        background: white;\r\n        padding: 0rem;\r\n        margin-bottom: 1rem;\r\n        margin-top: 1rem;\r\n        filter: none;\r\n    }\r\n\r\n    .cardContainer {\r\n        border-radius: 0.5rem;\r\n        padding: 1rem;\r\n        min-height: 10rem;\r\n        margin-bottom: 0.5rem;\r\n    }\r\n\r\n    .icon {\r\n        width: 2rem;\r\n        height: 2rem;\r\n        margin-top: 0rem;\r\n    }\r\n\r\n    .title {\r\n        font-size: 0.875rem;\r\n        margin-top: 0.2rem;\r\n        margin-bottom: 0.7rem;\r\n    }\r\n\r\n    .description {\r\n        font-size: 0.75rem;\r\n        font-weight: 300;\r\n        line-height: 1.2rem;\r\n        height: 4.5rem;        \r\n\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Details_container__Umbrs`,
	"cardContainer": `Details_cardContainer__S-Nyu`,
	"icon": `Details_icon__gRs9K`,
	"title": `Details_title__N3uM+`,
	"description": `Details_description__IfR+k`
};
export default ___CSS_LOADER_EXPORT___;
